/**
 * Component for project details
 */
//  Generic imports
import React from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

//  Motif imports
import { MotifIconButton } from '@ey-xd/motif-react/Button';
import MotifTabNavigation, { MotifTabControl } from '@ey-xd/motif-react/TabNavigation';

//  Internal imports
import './ProjectDetails.scss';

import { setUserProjects, setActiveProject, setProjectTransfers, setActiveTransfer } from "../../../redux/userSlice";
import Transfers from '../transfers/Transfers';
import Languages from '../languages/Languages';
import Review
 from "../review/Review";

//  Icon imports
import iconArrowBack from '../../../assets/images/arrow_back.svg';

export default function ProjectDetails() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { activeProject } = useSelector(state => state.user);
    const projectName = activeProject?.projectName;

    const Tabs = [
        {
            "id": 1,
            "elementId": "transfersTab",
            "title": "Transfers"
        },
        {
            "id": 2,
            "elementId": "languageTab",
            "title": "Language"
        },
        {
            "id": 3,
            "elementId": "reviewTab",
            "title": "Review"
        }
    ];

    const TabIds = { transfers: "transfersTab", language: "languageTab", review: "reviewTab" };

    const navToHome = () => {
        dispatch(setActiveProject({
            activeProject: null
        }));
        dispatch(setUserProjects({
            projects: null
        }));
        dispatch(setActiveTransfer({
            transfer: null
        }));
        dispatch(setProjectTransfers({
            transfers: null
        }));
        navigate('/');
    }

    /**
    * This method switches tabs.
    * @param {*} tab 
    */
    const handleTabClick = (tab) => {
        switch (tab.elementId) {
            case TabIds.transfers:
                document.getElementById(TabIds.transfers).style.display = "block";
                document.getElementById(TabIds.language).style.display = "none";
                document.getElementById(TabIds.review).style.display = "none";
                break;
            case TabIds.language:
                document.getElementById(TabIds.transfers).style.display = "none";
                document.getElementById(TabIds.language).style.display = "block";
                document.getElementById(TabIds.review).style.display = "none";
                break;
            case TabIds.review:
                document.getElementById(TabIds.transfers).style.display = "none";
                document.getElementById(TabIds.language).style.display = "none";
                document.getElementById(TabIds.review).style.display = "block";
                break;
            default:
        }
    };

    return (
        <div className="projectContainer">
            <div className="projectDetailsBreadcrumb">
                <MotifIconButton
                    aria-label="Click here to go back to Project Dashboard"
                    onClick={() => navToHome()}
                    className='btnBack'
                    data-testid="testIdBtnBack"
                >
                    <img src={iconArrowBack} alt='Previous' />
                </MotifIconButton>
                <span className='projectName textEllipsis'>{projectName}</span>
            </div>
            <div className='projectContent'>
                <MotifTabNavigation defaultActiveKey={0} className='projectTab'>
                    {
                        Tabs.map((tab) =>
                            <MotifTabControl key={tab.id} onClick={() => handleTabClick(tab)} className='btnTab'>
                                {tab.title}
                            </MotifTabControl>
                        )
                    }
                </MotifTabNavigation>
                <div className="tabParentContainer">
                    <div className="transfersTab" id="transfersTab">
                        <Transfers />
                    </div>
                    <div className="languageTab" id="languageTab">
                        <Languages />
                    </div>
                    <div className='reviewTab' id="reviewTab">
                        <Review />
                    </div>
                </div>
            </div>
        </div>
    )
}